import { Component, Inject, OnInit, ChangeDetectorRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RequestService, LayoutUtilsService, LoaderService } from '../../../shared/services';
import { urlSafeBase64Encoding } from '../../../shared/helpers';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/internal/Subscription';

interface ViewDialogData {
	title: string;
	data: any;
	confirmData: any;
	userId: string;
}

@Component({
	selector: 'app-language-dialog-modal',
	templateUrl: './custom-language-dialog.component.html',
	styleUrls: ['./custom-language-dialog.component.scss']
})
export class ModalLanguageDialogComponent implements OnInit {
	private subscriptions: Subscription[] = [];
	public langs: string[] = ['en', 'ja'];
	public isSuperAdmin: boolean = false;
	public languageSelected: string = 'en';
	constructor(private translate: TranslateService, private loader: LoaderService, private requestService: RequestService,
		public dialogRef: MatDialogRef<ModalLanguageDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: ViewDialogData) {
		//console.log('ViewDialogData', data);
		if (localStorage.getItem('languageSelected')) {
			this.languageSelected = localStorage.getItem('languageSelected');
		}
	}

	ngOnInit() {
		this.subscriptions.push(
			this.requestService.pageOrganization.subscribe((data) => {
				if (data) {
					let organization = data;
					let settings = this.requestService.getSettings(organization);
					this.langs = settings.langs;
				}
			})
		);
		this.subscriptions.push(
			this.requestService.currentUserSubject.subscribe((data) => {
				if (data) {
					this.isSuperAdmin = this.requestService.isUserRoleSuperAdmin();

					if (this.isSuperAdmin) {
						this.langs = ['en', 'ja'];
					}
				}
			})
		);
	}
	ngOnDestroy(): void {
		this.subscriptions.forEach((s) => s.unsubscribe());
	}
	closeModal(data): void {
		this.dialogRef.close(data);
	}
	changeLang(language: string) {
		localStorage.setItem('languageSelected', language);
		this.languageSelected = language;
		this.translate.use(language);
		this.loader.display(true);
		this.requestService.postRequest('user/language', `${this.data.userId}/update`, {
			language: this.languageSelected
		}, (data, error) => {
			this.loader.display(false);
			window.location.reload();
		});
	}
}
